import React from "react";
import Box from "../../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../../services/Notify";
import {ControlLabel, FormGroup} from "react-bootstrap";
import FormButtons from "../../component/Form/FormButtons";
import MaterialService from "../MaterialService";

class MaterialImportForm extends React.Component {

  service = new MaterialService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  submitForm() {
    const entity = this.friendlyName.value.split(',');

    this.service.importMaterials(entity).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => Notify.error('Falha ao salvar entidade:', error));
  }

  render() {
    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <FormGroup>
              <ControlLabel>Materiais</ControlLabel>
              <input type="text" className="form-control" placeholder="001,002,003"
                     required
                     name="friendlyName"
                     ref={friendlyName => this.friendlyName = friendlyName}/>
            </FormGroup>

            <FormButtons history={this.props.history}/>
          </form>
        </Box>);
  }
}

MaterialImportForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default MaterialImportForm;



// WEBPACK FOOTER //
// ./src/material/component/MaterialImportForm.js